import { customAxios } from "@/shared/lib/customAxios"
import type { ListRequest, ListResponse } from "@/shared/types/commonResponse"
import {
  useInfiniteQuery,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query"

// POST /star/gallery/list  ------------------------------ Gallery List

export interface GalleryContent {
  id: number
  starId: number
  title: string
  imageUrl: string
  regDt: string
}

export type GalleryListResponse = ListResponse<GalleryContent>

const GalleryList = ({
  Language,
  requestDto,
  angkorId,
}: ListRequest): Promise<GalleryListResponse> => {
  return customAxios
    .post<GalleryListResponse>("star/gallery/list", requestDto, {
      headers: {
        Language: Language,
        angkorId: angkorId,
      },
    })
    .then((res) => res.data)
}

export const useGalleryListQuery = (
  request: ListRequest,
  options?: { enabled?: boolean }
): UseQueryResult<GalleryListResponse, Error> => {
  return useQuery<GalleryListResponse, Error>({
    queryKey: ["galleryList", request],
    queryFn: () => GalleryList(request),
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: options?.enabled, // enabled 값 전달
  })
}

// POST /star/gallery/list  ------------------------------ Gallery List

// 1. 페이지네이션 파라미터 기본값
const PAGE_SIZE = 15

export const useGalleryInfiniteQuery = (
  baseRequest: Omit<ListRequest, "requestDto"> & {
    requestDto: Omit<ListRequest["requestDto"], "pageable">
  }
) => {
  return useInfiniteQuery<GalleryListResponse, Error>({
    queryKey: ["galleryInfiniteList", baseRequest],
    queryFn: ({ pageParam = 1 }) =>
      GalleryList({
        ...baseRequest,
        requestDto: {
          ...baseRequest.requestDto,
          pageable: {
            page: pageParam as number,
            size: PAGE_SIZE,
            sort: [],
          },
        },
      }),
    // getNextPageParam: 마지막 페이지 여부에 따라 다음 page 반환
    getNextPageParam: (lastPage) => {
      return lastPage.isLast ? undefined : lastPage.currentPage + 1
    },
    initialPageParam: 1,
  })
}
